export const ownInsurance = {
  FirstYear: "FIRST_YEAR",
  EntirePeriod: "ENTIRE_PERIOD",
  No: "NO",
  NoInsurance: "NO_INSURANCE"
};
